import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import TestimonialCard from './TestimonialCard';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const SectionContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: '100px 0',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)',
    pointerEvents: 'none'
  }
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: '60px',
  position: 'relative',
  zIndex: 1
}));

const QuoteIconWrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '70px',
  height: '70px',
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  marginBottom: '20px',
  '& svg': {
    fontSize: '36px',
    color: '#ffffff',
    opacity: 0.9
  }
}));

const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  letterSpacing: '2px',
  textTransform: 'uppercase',
  color: 'rgba(255, 255, 255, 0.9)',
  marginBottom: '12px'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Montserrat, sans-serif',
  fontSize: '42px',
  fontWeight: 700,
  lineHeight: '1.2',
  color: '#ffffff',
  marginBottom: '16px',
  [theme.breakpoints.down('md')]: {
    fontSize: '36px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px'
  }
}));

const SectionDescription = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '1.6',
  color: 'rgba(255, 255, 255, 0.85)',
  maxWidth: '600px',
  margin: '0 auto'
}));

const TestimonialsGrid = styled(Grid)(({ theme }) => ({
  position: 'relative',
  zIndex: 1
}));

const EmptyState = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: '60px 20px',
  color: 'rgba(255, 255, 255, 0.7)',
  fontSize: '16px',
  fontFamily: 'Inter, sans-serif'
}));

const TestimonialsSection = ({ testimonials = [] }) => {
  // Only show section if there are testimonials
  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      <Container maxWidth="lg">
        <SectionHeader>
          <QuoteIconWrapper>
            <FormatQuoteIcon />
          </QuoteIconWrapper>
          <SectionSubtitle>Testimonials</SectionSubtitle>
          <SectionTitle>What Our Clients Say</SectionTitle>
          <SectionDescription>
            Don't just take our word for it - hear from our satisfied customers
          </SectionDescription>
        </SectionHeader>
        
        <TestimonialsGrid container spacing={4}>
          {testimonials.map((testimonial) => (
            <Grid item xs={12} md={6} key={testimonial.id}>
              <TestimonialCard testimonial={testimonial} />
            </Grid>
          ))}
        </TestimonialsGrid>
      </Container>
    </SectionContainer>
  );
};

export default TestimonialsSection;